//  获取用户信息
export const SET_USER_INFO = 'SET_USER_INFO'

//  设置加载窗
export const SET_LOADING = 'SET_LOADING'
